module.exports = __webpack_public_path__ + "static/img/5.a433d609.jpg";